/* ltt-search-popup.js — lets the bottom tab bar open the header's search popup.

   The popup itself is Dawn's <details-modal> in snippets/header-search.liquid:
   it already handles focus, Escape and the overlay, so nothing is rebuilt here.
   This only forwards a tap on the bar's search tab to that same <summary>, and
   focuses the input once the popup is open.

   If the popup is not on the page for any reason, the tab falls back to the
   search PAGE rather than doing nothing. */
(function () {
  'use strict';
  if (window.lttSearchPopupBound) return;
  window.lttSearchPopupBound = true;

  function openSearch() {
    var summary = document.querySelector('[data-ltt-search-summary]');
    if (!summary) return false;

    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return false;

    // Clicking the <summary> is what <details-modal> listens for; setting
    // `details.open` directly skips its own bookkeeping.
    if (!details.open) summary.click();

    // The input only exists once the popup is in the DOM, and focusing it in
    // the same frame as the click loses the focus to the summary itself.
    requestAnimationFrame(function () {
      var input = details.querySelector('input[type="search"], input[name="q"]');
      if (input) input.focus();
    });
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ltt-search-open]');
    if (!trigger) return;

    event.preventDefault();
    if (!openSearch()) {
      // No popup on this page — go to the real search page instead of
      // swallowing the tap.
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      window.location.href = root + 'search';
    }
  });
})();
